
export default {
  props: {
    block: {
      type: Object,
      required: true,
    },
    partnerPosts: {
      type: Array,
      default: () => [],
    },
    perPage: {
      type: Number,
      default: 4,
    },
    hasLink: {
      type: Boolean,
      default: true,
    },
    categories: {
      type: [Array, Boolean, Object],
      default: () => [],
    },
  },
  data () {
    return {
      partners: [],
      sliderItems: [],
      carouselOptions: {
        slidesPerView: 1,
        spaceBetween: 32,
        slidesPerGroup: 1,
        breakpoints: {
          480: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          640: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          768: {
            slidesPerView: this.perPage,
            slidesPerGroup: this.perPage,
          },
        },
      },
      carousel: null,
    };
  },
  computed: {
    sliderName () {
      if (this.block.title) {
        return `carousel-${this.slugify(this.block.title)}`;
      }
      return `carousel-${Math.floor(Math.random() * 1000)}`;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getPartners();
    });
  },
  methods: {
    async getPartners () {
      const queryParams = {
        fields: `id,title,acf,image,slug`,
        posts: {
          post_type: `partner`,
          posts_per_page: 1000,
          post_status: `publish`,
          cat: this.categories,
          orderby: `menu_order`,
          order: `DESC`,
        },
        options: {
          image_size: `medium_large`,
        },
      };

      const request = await this.$getPosts(`/posts`, queryParams);
      if (request !== null) {
        this.partners = request;
      }
    },
    nextSlide () {
      this.carousel.slideNext(500);
    },
    prevSlide () {
      this.carousel.slidePrev(500);
    },
  },
};
